/** @format */

import { Component, EventEmitter, Input, Output } from "@angular/core"

@Component({
	standalone: false,
	selector: "app-checked-card",
	templateUrl: "./checked-card.component.html",
	styleUrls: ["./checked-card.component.css"],
})
export class CheckedCardComponent {
	// @Input() data: any
	@Input() title: string = ""
	@Input() dataTypeName: string = ""
	@Input() enableDateTime: boolean = false
	@Input() datetime: string = ""
	@Input() description: string = ""
	@Input() icon: string = ""
	@Input() isDraggable: boolean = false
	@Input() isSelected: boolean = false
	@Output() onClickIcon: EventEmitter<any> = new EventEmitter()
	@Output() datetimeChange: EventEmitter<string> = new EventEmitter<string>();

	selectIcon() {
		this.onClickIcon.emit()
	}
	minDateTime: string = ""

	setMinDateTime() {
		const jamaicaTime = new Date(new Date().toLocaleString('en-US', { timeZone: 'America/Jamaica' }));
		const yyyy = jamaicaTime.getFullYear();
		const MM = String(jamaicaTime.getMonth() + 1).padStart(2, '0');
		const dd = String(jamaicaTime.getDate()).padStart(2, '0');
		const HH = String(jamaicaTime.getHours()).padStart(2, '0');
		const mm = String(jamaicaTime.getMinutes()).padStart(2, '0');

		this.minDateTime = `${yyyy}-${MM}-${dd}T${HH}:${mm}`;
	}

	ngOnInit() {
		this.setMinDateTime()
	}
}
